import { Component, OnInit } from '@angular/core';
import { ActivatedRoute }    from '@angular/router';
import { Location }          from '@angular/common';

import { GuideService }      from './guide.service';
import { Guide }             from './../../models/guide/guide';


@Component({
  selector: 'app-guides',
  templateUrl: './guides.component.html',
  styleUrls: ['./guides.component.less']
})

export class GuidesComponent implements OnInit {
  guides: Guide[];

  constructor(
    private guideService: GuideService,
    private route: ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit(): void {
    this.guideService
        .getGuides()
        .subscribe(guides => this.guides = guides);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/guides/guides.component.ts